export default __webpack_public_path__ + "static/media/marketing-2.21c3c447.jpg";